import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CreateVendor from '../components/createVendor';
import * as InvoiceVendorAction from '../actions/invoiceVendorAction';
import * as authActions from '../actions/authActions';
import * as SnackBarAction from '../actions/snackbarAction';

function mapStateToProps(state) {
  return {
    ...state.Vendor,
    countryCodes: state.LoginReducer.countryCodes,
    userInfo: state?.Chargecard?.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...InvoiceVendorAction,
      ...authActions,
      ...SnackBarAction
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateVendor);
